<template>
  <div class="lcu-program-sideBar">
    <div
      class="lcu-program-section"
      v-for="section in (program.sections || [])"
      :key="section.id">
      <div class="lcu-section-name">
        {{ section.title }}
      </div>
      <div class="lcu-section-modules">
        <div
          class="lcu-module"
          :class="{
            'lcu-active-module': activeModule.id === module.id
          }"
          v-for="module in section.modules"
          :key="module.id">
            <button
              @click.stop="() => onModuleClick(module, section)"
              :disabled="moduleNoteStarted({ section, module })"
              :class="{
                'lcu-module-nameOpen': toggles[module.id],
                'lcu-module-locked': moduleNoteStarted({ section, module }),
                'lcu-module-completed': moduleCompleted({ section, module }),
              }"
              class="lcu-module-name lcu-button-scope">
              <span class="lcu-module-title">{{ module.title }}</span>
              <span class="lcu-module-dropdown" v-if="module.items.length > 0" />
            </button>
            <div
              class="lcu-module-items"
              v-show="toggles[module.id]">
              <button
                class="lcu-module-item lcu-button-scope"
                @click.stop="''"
                v-for="item in module.items"
                :key="item.id">
                <span class="lcu-item-lock" />
                <span class="lcu-item-title">
                  {{ item.title }}
                </span>
              </button>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'program-side-bar',
  data() {
    return {
      // durations: {},
      toggles: {},
    };
  },
  props: {
    currentIndex: {
      type: Number,
      default: 0,
    },
    highestIndex: {
      type: Number,
      default: 0,
    },
    highestCompletedIndex: {
      type: Number,
      default: 0,
    },
    activeModule: {
      type: [Object, Boolean],
      default: () => ({}),
    },
    userData: {
      type: Object,
      default: () => ({}),
    },
    program: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    this.buildToggles();
  },
  methods: {
    buildToggles() {
      (this.program.sections || []).forEach((section) => {
        section.modules.forEach((module) => {
          this.toggles[module.id] = false;
        });
      });
    },
    onModuleClick(module, section) {
      if (module.items.length > 0) {
        this.toggles[module.id] = !this.toggles[module.id];
      } else {
        this.$emit('on-module-click', { module, section });
      }
    },
    sectionClick({ index }) {
      const highest = this.highestIndex;
      if (index > highest) {
        return;
      }

      if (index > this.highestCompletedIndex + 1) {
        return;
      }

      this.$emit('on-section-click', { index });
    },
    moduleNoteStarted({ section, module }) {
      return !(this.userData.programs[this.program.slug]?.sections[section.id]?.modules[module.id]);
    },
    moduleCompleted({ section, module }) {
      const program = this.userData.programs[this.program.slug] || {};
      const sec = program.sections[section.id];
      return sec?.modules[module.id]?.progress?.completed;
    },
    getDurations(section) {
      if (section.type === 'video') {
        const video = document.createElement('video');
        video.src = section.video.sources[0]?.src;
        video.addEventListener('loadedmetadata', () => {
          this.durations[section.id] = `(${this.getDisplayTime(video.duration)})`;
          video.remove();
        });
      }
    },
    getDisplayTime(stamp) {
      const current = Number(stamp);
      const hour = Math.floor(current / 3600);
      const minute = Math.floor((current % 3600) / 60);
      const second = Math.floor((current % 3600) % 60);
      const hDisplay = hour > 0 ? `${hour}:` : '';
      const mDisplay = `${minute}:`;
      const sDisplay = second < 10 ? `0${second}` : second;
      return hDisplay + mDisplay + sDisplay;
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-program-sideBar {
  background-color: $off-white;
  border-right: 1px solid $page-border;
}

.lcu-section-name {
  border-bottom: 1px solid $page-border;
  border-top: 1px solid $page-border;
  padding: 10px;
}

.lcu-program-section {
  &:first-child {
    .lcu-section-name {
     border-top: 0;
    }
  }
}

.lcu-button-scope {
  color: inherit;
  border: 0;
  font-family: inherit;
  font-size: inherit;
  text-align: left;
  width: 100%;

  &:hover {
    cursor: pointer;
  }
}

.lcu-module-name {
  background-color: #e8e8e8;
  padding: 10px;
  padding-left: 20px;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: max-content 1fr max-content;
  align-items: center;

  &::before {
    content: '';
  }
}

.lcu-module-locked {

  .lcu-module-title {
    opacity: .6;
  }

  &::before {
    font-family: 'lcu';
    content: '\e81d';
    display: inline-block;
  }
}

.lcu-module-dropdown {
  transition-duration: .2s;

  &:after {
    color: rgba($black, .25);
    font-family: 'lcu';
    content: '\e817';
    font-size: 12px;
    display: inline-block;
  }
}

.lcu-item-lock {

  &:after {
    color: $legacy-primary;
    font-family: 'lcu';
    content: '\e81d';
    display: inline-block;
  }
}

.lcu-item-unlock {

  &:after {
    content: ' ';
  }
}

.lcu-module-completed {
    &:before {
    color: #859db5;
    font-family: 'lcu';
    content: '\e820';
    display: inline-block;
  }
}

.lcu-module-nameOpen {
  border-bottom: 1px solid $page-border;

  .lcu-module-dropdown {
    transform: rotate(180deg);
  }
}

.lcu-module-item {
  background-color: #dcdcdc;
  border-bottom: 1px solid $page-border;
  padding: 10px;
  padding-left: 30px;
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-gap: 5px;

  &:last-child {
    border-bottom: 0;
  }
}

.lcu-module {
  border: 0;
  border-bottom: 1px solid $page-border;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  text-align: left;
  width: 100%;

  &:last-child {
    border-bottom: 0;
  }
}

.lcu-active-module {

  .lcu-module-name {
    background-color: $legacy-secondary;
    color: $white;
  }

  .lcu-module-completed {
    &:before {
    color: rgba($white, .7);
  }
}
}

.lcu-moduleSection-disabled {

  .lcu-module-sectionCrumb {
    opacity: .3;
  }

  &:hover {
    cursor: default;
  }
}

.lcu-module-sectionCrumb {
  align-items: center;
  color: rgba($white, .8);
  display: flex;

  &:before {
    content: '\e823';
    display: inline-block;
    font-family: 'lcu';
    font-size: 16px;
    margin-right: 8px;
  }
}

.lcu-crumb-video {

  &:before {
    content: '\e824';
  }
}

.lcu-module-sectionCircle {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
}

.lcu-module-sectionStat {
  background-color: #2a2a2a;
  border: 1px solid rgba($white, .2);
  border-radius: 50%;
  height: 14px;
  width: 14px;
}

.lcu-module-sectionComplete {
  background-color: $black;
  border-color: $black;
}

.lcu-moduleSection-active {

  .lcu-module-sectionStat {
    background-color: $legacy-primary;
    border-color: #9c917a;
  }
}
</style>
